import './CardGrid.css';

export default function CardGrid({ min = '250px', gap = '2rem', children, className = '', style }) {
    return (
      <div
        className={`card-grid ${className}`.trim()}
        style={{
          '--card-grid-min': min,
          '--card-grid-gap': gap,
          ...style,
        }}
      >
        {children}
      </div>
    );
  }
  